const mapDropDown = (data) => (Object.assign({ type: 'drop-down' }, data));
const mapMultiSelectDropDownField = (data) => (Object.assign({ type: 'multi-drop-down' }, data));
const mapTextField = (data) => (Object.assign(Object.assign({}, data), { type: 'text' }));
const mapNumberRangeField = (data) => (Object.assign(Object.assign({}, data), { type: 'number-range' }));
const mapTextAreaField = (data) => (Object.assign(Object.assign({}, data), { type: 'text-area' }));
const mapDatePicker = (data) => (Object.assign({ type: 'date-picker' }, data));
const mapDatePickerRange = (data) => (Object.assign({ type: 'date-picker-range' }, data));
const mapNumberField = (data) => (Object.assign({ type: 'number' }, data));
const mapPasswordField = (data) => (Object.assign({ type: 'password' }, data));
const mapSeparatorField = () => {
    const result = {
        type: 'separator',
        field: undefined,
    };
    return result;
};
const mapCustomField = ({ component }) => {
    const result = {
        type: 'custom',
        field: undefined,
        component,
    };
    return result;
};
const mapRadioCardsField = (data) => (Object.assign({ type: 'radio-cards' }, data));
const mapRadioButtonField = (data) => (Object.assign({ type: 'radio-button' }, data));
const mapCheckBoxField = (data) => (Object.assign(Object.assign({}, data), { type: 'checkbox' }));

export { mapCheckBoxField, mapCustomField, mapDatePicker, mapDatePickerRange, mapDropDown, mapMultiSelectDropDownField, mapNumberField, mapNumberRangeField, mapPasswordField, mapRadioButtonField, mapRadioCardsField, mapSeparatorField, mapTextAreaField, mapTextField };
